const filterItem = () => ({
	sorting: {},
	statusOutlet: [],
	kota: [],
	statusLayanan: [],
	jenisLayananSnapclean: [],
	jenisMesinSnapclean: [],
	jenisTransaksi: [],
	jenisPembayaran: [],
	jenisPembayaranSnapclean: [],
	jenisPembayaranAkunDebit: "",
	jenisPembayaranAkunEDC: "",
	tipePembayaran: [],
	satuan: [],
	kategoriLayanan: [],
	kategoriMesin: [],
	kategoriRak: [],
	layananTerhubung: [],
	layananOwner: [],
	layananSnapcleanOwner: [],
	masaAktif: [],
	bonusEpayment: [],
	statusWorkshop: [],
	statusKaryawan: [],
	statusAbsen: [],
	statusTransaksi: [],
	statusTransaksiSnapclean: [],
	sumberAbsen: [],
	statusGaji: [],
	statusTanggungan: [],
	statusPembayaran: [],
	notaDihitung: [],
	kontakKonsumen: [],
  konsumen: [],
	agama: [],
	outlet: [],
	oneOutlet: "",
	workshop: [],
	akunSettlement: [],
	providerEdc: [],
	mesinEdc: [],
	statusKonfirmasi: [],
	jenisLayananReguler: [],
	deposit: [],
	statusDeposit: [],
	epayment: [],
	outletNonaktif: [],
	workshopNonaktif: [],
	paketKedaluarsa: [],
	dataKonsumen: [],
	karyawan: "",
	mesinSnap: "",
	tahapan: [],
	statusKoneksi: [],
	statusMesinEdc: [],
	statusMesin: [],
	sensorPintu: [],
	statusPintu: [],
	jenisMesin: [],
	jenisSnapConsole: 0,
	rekeningAtasNama: [],
	jenisTransaksiRiwayatTransfer: [],
	uangMasukRiwayatTransfer: [],
	uangKeluarRiwayatTransfer: [],
	akunKeuanganGlobal: "",
	akunBiayaItemBiaya: {
		idbiaya: "",
		iditemBiaya: "",
	},

	periode: {
		filterBy: "",
		startDate: "",
		endDate: "",
		month: "",
		year: "",
	},
	afiliasiOwner:"0",
	// additional
	filterKolomTransaksi: "",
	filterRentangTanggalKonsumen: "",
	filterRentangTanggalKonsumenSnapclean: "",
	filterLayananOwner: "",
	filterLayananSnapcleanOwner: "",
	filterSaldoEpayment: {
		minimal: 0,
		maksimal: 0,
	},
	idoutlet_snap: "",
	idmaster_member: [],
	idpromo: "",
	jenisKonsumen: [],
	metodeTopup: [],
});

const filterSetting = () => ({
	outletNonaktif: false,
	workshopNonaktif: false,
	paketKedaluarsa: false,
	sorting: {
		show: false,
		components: {
			createdAt: false,
			nama: false,
			absensi: false,
			harga: false,
			gaji: false,
			banyakTransaksiKonsumen: false,
			transaksiKonsumen: false,
			nominalTransaksi: false,
			masaAktifDeposit: false,
			kuotaDeposit: false,
		}
	},
	statusOutlet: false,
	kota: false,
	outlet: false,
	oneOutlet: false,
	workshop: false,
	akunSettlement: false,
	providerEdc: false,
	mesinEdc: false,
	deposit: false,
	statusDeposit: false,
	epayment: false,
	statusLayanan: false,
	jenisLayananSnapclean: false,
	jenisMesinSnapclean: false,
	jenisTransaksi: false,
	jenisPembayaran: false,
	jenisPembayaranSnapclean: false,
	tipePembayaran: false,
	satuan: false,
	kategoriLayanan: false,
	kategoriMesin: false,
	kategoriRak: false,
	layananTerhubung: false,
	layananOwner: false,
	layananSnapcleanOwner: false,
	masaAktif: false,
	bonusEpayment: false,
	statusWorkshop: false,
	statusKaryawan: false,
	statusAbsen: false,
	statusTransaksi: false,
	statusTransaksiSnapclean: false,
	sumberAbsen: false,
	statusGaji: false,
	statusTanggungan: false,
	statusPembayaran: false,
	notaDihitung: false,
	kontakKonsumen: false,
	agama: false,
	statusKonfirmasi: false,
	jenisLayananReguler: false,
	dataKonsumen: false,
	konsumen: false,
	karyawan: false,
	mesinSnap: false,
	tahapan: false,
	periode: false,
	statusKoneksi: false,
	statusMesinEdc: false,
	statusMesin: false,
	statusSensorPintu: false,
	jenisMesin: false,
	jenisSnapConsole: false,
	afiliasiOwner: false,
	rekeningAtasNama: false,
	jenisTransaksiRiwayatTransfer: false,
	tanggalTransfer: false,
	// filterKolomTransaksi: false,
	akunKeuanganGlobal: false,
	akunBiayaItemBiaya: false,
	filterSaldoEpayment: false,
	idmaster_member: false,
})

const filter = () => ({
	sortBy: "",
	orderBy: "",
})

const state = {
	filterItem: filterItem(),
	filterSetting: filterSetting(),
	filter: filter(),
}

const getters = {
	getFilterItem: (state) => state.filterItem,
	getFilterSetting: (state) => state.filterSetting,
	getFilter: (state) => state.filter,
}

const actions = {}

const mutations = {
	setFilterItem: (state, filterItem) => {
		state.filterItem = filterItem
	},
	resetFilterItem: (state) => {
		state.filterItem = filterItem()
	},
	setFilterSetting: (state, filterSetting) => {
		state.filterSetting = filterSetting
	},
	resetFilterSetting: (state) => {
		state.filterSetting = filterSetting()
	},
	setFilter: (state, filter) => {
		state.filter = filter
	},
	resetFilter: (state) => {
		state.filter = filter()
	},

	// custom
	setDefaultFilter: (state) => {
		state.filter.sortBy = "nama"
		state.filter.orderBy = "ASC"
	},
	flushFilter: (state) => {
		state.filter = filter()
		state.filterItem = filterItem()
		state.filterSetting = filterSetting()
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
}